

export class BranchDetailAddInput implements IBranchDetailAddInput {
    /** The auto-generated id of the tbl_company_details */
    companyDetailsId!: number;
    /** The branch code with 100 character limit */
    branchCode!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The street 1 with 255 character limit */
    street1!: string;
    /** The street 2 with 255 character limit */
    street2!: string;
    /** The Reference id of the tbl_city table */
    cityId!: number;
    /** The ZIP code with 6 character limit */
    zipCode!: string;
    /** The contact person with 255 character limit */
    contactPerson!: string;
    /** The email id of user with 320 character limit */
    email!: string;
    /** The help desk number with 13 character limit */
    telephoneNumber!: string;
    /** The mobile number with 10 character limit */
    mobileNumber!: string;
    /** The fax number with 20 character limit */
    faxNumber!: string;
    /** The fax number with 2000 character limit */
    description!: string;

    constructor(data?: IBranchDetailAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchCode = _data["branchCode"];
            this.branch = _data["branch"];
            this.street1 = _data["street1"];
            this.street2 = _data["street2"];
            this.cityId = _data["cityId"];
            this.zipCode = _data["zipCode"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.faxNumber = _data["faxNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BranchDetailAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchCode"] = this.branchCode;
        data["branch"] = this.branch;
        data["street1"] = this.street1;
        data["street2"] = this.street2;
        data["cityId"] = this.cityId;
        data["zipCode"] = this.zipCode;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["telephoneNumber"] = this.telephoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["faxNumber"] = this.faxNumber;
        data["description"] = this.description;
        return data; 
    }
}

export interface IBranchDetailAddInput {
    /** The auto-generated id of the tbl_company_details */
    companyDetailsId: number;
    /** The branch code with 100 character limit */
    branchCode: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The street 1 with 255 character limit */
    street1: string;
    /** The street 2 with 255 character limit */
    street2: string;
    /** The Reference id of the tbl_city table */
    cityId: number;
    /** The ZIP code with 6 character limit */
    zipCode: string;
    /** The contact person with 255 character limit */
    contactPerson: string;
    /** The email id of user with 320 character limit */
    email: string;
    /** The help desk number with 13 character limit */
    telephoneNumber: string;
    /** The mobile number with 10 character limit */
    mobileNumber: string;
    /** The fax number with 20 character limit */
    faxNumber: string;
    /** The fax number with 2000 character limit */
    description: string;
}

